import { CurrentHeatFragment } from "graphql/heat.types";

export const isHeatSupported = (currentHeats: CurrentHeatFragment[] | undefined) => !!currentHeats?.every(heat => heat
    && !["placing", "timing"].includes(heat.config.calculator as string)
    && !heat.config.categories
    && !heat.config.categoryGroups
    && !heat.eventDivision.formatDefinition?.isTeams
    && !heat.eventDivision.formatDefinition?.hasStartlist
    && !heat.eventDivision.formatDefinition?.runBased
);
